import { render, staticRenderFns } from "./BasicNewForm.vue?vue&type=template&id=2454dc64&scoped=true"
import script from "./BasicNewForm.vue?vue&type=script&lang=js"
export * from "./BasicNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2454dc64",
  null
  
)

export default component.exports